import React from "react";

// Yellow brick road perspective logo mark
export const BrickRoadMark = ({ className = "h-10 w-10" }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="brickShade" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FDE047" />
        <stop offset="100%" stopColor="#CA8A04" />
      </linearGradient>
    </defs>
    {/* perspective bricks receding to a vanishing point */}
    <polygon points="6,58 58,58 50,50 14,50" fill="url(#brickShade)" stroke="#422006" strokeWidth="1" />
    <polygon points="14,49 50,49 44,42 20,42" fill="url(#brickShade)" stroke="#422006" strokeWidth="1" />
    <polygon points="20,41 44,41 40,35 24,35" fill="url(#brickShade)" stroke="#422006" strokeWidth="1" />
    <polygon points="24,34 40,34 37,29 27,29" fill="url(#brickShade)" stroke="#422006" strokeWidth="1" />
    <polygon points="27,28 37,28 35,24 29,24" fill="url(#brickShade)" stroke="#422006" strokeWidth="1" />
    <polygon points="29,23 35,23 34,20 30,20" fill="url(#brickShade)" stroke="#422006" strokeWidth="1" />
    {/* divider lines */}
    <line x1="32" y1="58" x2="32" y2="20" stroke="#422006" strokeWidth="0.8" />
  </svg>
);

export const BrandLogo = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <BrickRoadMark className="h-9 w-9" />
    <div className="leading-tight">
      <div className="font-display text-xl font-extrabold tracking-tight text-stone-50">
        Oz <span className="text-yellow-500">&amp;</span> Ends
      </div>
      <div className="text-[10px] tracking-[0.25em] uppercase text-stone-400 font-semibold">
        LLC · Eau Claire, WI
      </div>
    </div>
  </div>
);

export default BrandLogo;
